import fetch from '@/axios/promise';
import  {CM_PAY_URL} from  '@/config/constant';
export function payRecordList(query) {
  return invoke(query,'/getCmPayList','POST');
}
export function selectPayRecordById(query) {
  return invoke(query,'/selectPayRecordById','GET');
}
export function selectCtripsProjInfo(query) {
  return invoke(query,'/selectCtripsProjInfo','POST');
}
export function selectCtripsPerson(query) {
  return invoke(query,"/selectCtripPersonById",'POST')
}
export function updatePayStatus(query) {
  return invoke(query,"/updatePayRecordStatus",'GET')
}
export function approvePayRecord(query) {
  return invoke(query,'/approvePayRecord','POST')
}
// 调用
function invoke(query,url,method){
  return fetch({
    url: CM_PAY_URL+url,
    method: method,
    params: query
  });
}



// WEBPACK FOOTER //
// ./src/api/contract/payRecord.js